import type { ButtonHTMLAttributes, ReactNode } from 'react'
import { Link, type LinkProps } from 'react-router-dom'

type Variant = 'primary' | 'secondary' | 'action' | 'ghost' | 'danger' | 'navy'

export function Button({ children, variant = 'primary', size = 'md', className = '', ...props }: ButtonHTMLAttributes<HTMLButtonElement> & { children: ReactNode; variant?: Variant; size?: 'sm' | 'md' | 'lg' }) {
  return <button className={`btn btn--${variant} btn--${size} ${className}`} {...props}>{children}</button>
}

export function ButtonLink({ children, variant = 'primary', size = 'md', className = '', ...props }: LinkProps & { children: ReactNode; variant?: Variant; size?: 'sm' | 'md' | 'lg' }) {
  return <Link className={`btn btn--${variant} btn--${size} ${className}`} {...props}>{children}</Link>
}
